<script>
  import { marked } from "marked";
  import { renderSanitizedHTML } from "$lib/utilities";
  import { isExternalUrl, correctedUrl } from "$lib/utilities/url-helpers";
  import { textToId } from "$lib/utilities/dom-helpers";

  import ExternalLinkLabel from "$lib/components/ExternalLinkLabel.svelte";
  import { page } from "$app/stores";
  import { onMount } from "svelte";

  export let input;
  export let id;
  let clazz = "";
  export { clazz as class };

  let isExternal = false;

  let externalLinks = {};
  let origin;

  $: origin = $page.url?.origin;

  marked.use({
    extensions: [
      {
        name: "strong",
        renderer(token) {
          return `<span class="font-bold !p-0">${token.text}</span>`;
        }
      },
      {
        name: "link",
        renderer(token) {
          let href = token.href;
          let text = token.text;
          isExternal = isExternalUrl(href, origin);
          let linkToRender = correctedUrl(href);

          if (isExternal) {
            const externalId = `markdown-link-${id}` || `markdown-link-${textToId(text)}`;
            externalLinks[externalId] = text;

            return `<a
              id="${externalId}"
              class="btn-link !p-0 markdown-external no-underline center"
              data-sveltekit-reload
              href="${linkToRender}"
              aria-haspopup="false"
              aria-expanded="false"
              target="_blank" 
              rel="noopener noreferrer"
            ></a>`;
          } else {
            return `<a
              id="${id}"
              class="btn-link !p-0"
              data-sveltekit-reload
              href="${linkToRender}"
            >${text}</a>`;
          }
        }
      }
    ]
  });

  marked.Renderer.prototype.paragraph = (text) => {
    return `<p class='!p-0'>${text}</p>`;
  };

  let htmlText = renderSanitizedHTML(input);

  onMount(() => {
    Object.keys(externalLinks).forEach((l) => {
      let link = document.getElementById(l);
      if (link.classList.contains("markdown-external")) {
        link.classList.remove("markdown-external");

        new ExternalLinkLabel({
          target: link,
          props: { text: externalLinks[l], iconClass: "!inline align-top" }
        });
      }
    });
  });
</script>

{#if input}
  <div class={clazz} {id}>
    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
    {@html htmlText}
  </div>
{/if}
